import { useEffect, useState } from 'react';
import { globalEmitter } from '../helpers/emitter';
import { FormValidate } from './FormValidate';
import { Modal } from './Modal';
import { TextInput } from './TextInput';
import { SelectInput } from './SelectInput';
import { OmneoList, type_WISHLIST_DASHBOARD_STATE } from '../types';
import { closeModal } from '../helpers/useModal';

declare var wishlistDashboardState: type_WISHLIST_DASHBOARD_STATE

export function WishlistSettingList ({ lists, currentList }: { lists: OmneoList[], currentList: OmneoList }) {
  return (
    <Modal
      id="setting-list-slideout"
      className="modal-wishlist top-auto"
      content={<ModalSettingListContent lists={lists} currentList={currentList} />}
      type="slideout"
    />
  )
}

function ModalSettingListContent({ lists, currentList }: { lists: OmneoList[], currentList: OmneoList }) {
  const [nameList, setNameList] = useState(currentList.name)
  const [key, setKey] = useState(0)

  const listPrivacy = [
    {
      "name": "Private",
      "value": "private"
    },
    {
      "name": "Public",
      "value": "public"
    }
  ]

  const showMessageError = (message: string) => {
    globalEmitter.emit('triggerNotification', { message, type: 'error' })
  }

  const showMessSuccess = (message: string) => {
    globalEmitter.emit('triggerNotification', { message, type: 'success' })
  }

  const validateNameDuplicate = (name: String, lists: OmneoList[]) => {
    return lists.filter((item: OmneoList) => item.id !== currentList.id).some((list: OmneoList) => list.name.toLowerCase().trim() === name.toLowerCase().trim())
  }

  const saveSetting = async (formEl: React.MutableRefObject<null>) => {
    if (!formEl) return
    const formData = new FormData(formEl)
    const name = formData.get('name')
    const privacy = formData.get('privacy')

    if (currentList.name.toLowerCase().trim() !== 'wishlist') {
      if (!name) {
        return
      }
  
      if (validateNameDuplicate(name, lists)) {
        showMessageError('Update list failed')
      } else {
        try {
          const dataShare = {
            is_shared: currentList.is_shared,
            share_id: currentList.shares[0]?.id || 0,
            new_share: privacy === 'public'
          }
          let isShare = false
          if (dataShare.is_shared !== dataShare.new_share) {
            isShare = true
            if (dataShare.new_share) {
              await window.omneoService.shareWishlist(currentList.id)
            } else {
              await window.omneoService.deleteWishlistShare(currentList.id, dataShare.share_id)
            }
          }
          if (!isShare && name.toString().toLowerCase().trim() === currentList.name.toLowerCase().trim()) {
            showMessageError('Update list failed')
            closeModal('setting-list-slideout')
          } else {
            const list = await window.omneoService.updateList(currentList.id, name.toString())
            if (list) {
              globalEmitter.emit('updateList', { list })
              showMessSuccess('Update list successfully')
              closeModal('setting-list-slideout')
            } else {
              showMessageError('Update list failed')
            }
          }
        } catch (error) {
          console.log(error)
          showMessageError('Update list failed')
        }
      }
    } else {
      try {
        const name = 'wishlist'
        const dataShare = {
          is_shared: currentList.is_shared,
          share_id: currentList.shares[0]?.id || 0,
          new_share: privacy === 'public'
        }
        let isShare = false
        if (dataShare.is_shared !== dataShare.new_share) {
          isShare = true
          if (dataShare.new_share) {
            await window.omneoService.shareWishlist(currentList.id)
          } else {
            await window.omneoService.deleteWishlistShare(currentList.id, dataShare.share_id)
          }
        }
        if (!isShare) {
          showMessageError('Update list failed')
          closeModal('setting-list-slideout')
        } else {
          const list = await window.omneoService.updateList(currentList.id, name.toString())
          if (list) {
            globalEmitter.emit('updateList', { list })
            showMessSuccess('Update list successfully')
            closeModal('setting-list-slideout')
          } else {
            showMessageError('Update list failed')
          }
        }
      } catch (error) {
        console.log(error)
        showMessageError('Update list failed')
      }
    }
  }

  const handleDelete = async () => {
    try {
      const res = await window.omneoService.deleteList(currentList.id)
      if (res) {
        globalEmitter.emit('deleteList', { list: currentList })
        showMessSuccess('list deleted successfully')
        closeModal('setting-list-slideout')
      } else {
        showMessageError('Delete list failed')
      }
    } catch (error) {
      console.log(error)
      showMessageError('Delete list failed')
    }
    closeModal('setting-list-slideout')
  }

  useEffect(() => {
    setKey(Math.random())
  }, [currentList]);

  return (
    <FormValidate
      key={key}
      id={'wishlist-settings'}
      submitForm={saveSetting}
    >
      <h3 className="text-base text-deep-grey uppercase mb-[22px] text-left md:mb-6">{wishlistDashboardState.settings.title}</h3>
      {currentList.name.toLowerCase().trim() !== 'wishlist' &&
        <TextInput
          id="wishlist_name"
          type="text"
          label="Name"
          name="name"
          placeholder="enter wishlist name"
          classWrap="mb-[22px] md:mb-6"
          required={true}
          value={nameList}
          onInput={setNameList}
        />
      }
      <SelectInput
        id="wishlist_privacy"
        label="Privacy"
        name="privacy"
        value={currentList.is_shared ? 'public' : 'private'}
        items={listPrivacy}
        wrapClass="mb-[22px] md:mb-6"
      />
      <p className="text-xs text-deep-grey mb-[22px] md:mb-6">{wishlistDashboardState.settings.description}</p>
      <button className="Button Button--tertiary w-full" type={'submit'}>{wishlistDashboardState.settings.save}</button>
      {currentList.name.toLowerCase().trim() !== 'wishlist' && <button className="Button Button--secondary-dark w-full mt-3" type={'button'} onClick={handleDelete}>{wishlistDashboardState.settings.delete}</button>}
    </FormValidate>
  )
}
